export default __webpack_public_path__ + "static/media/26-min.20d5f63e.png";